module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/129.d35acd3b.png";